// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './WizardComp.css';
import qs from 'query-string';
import { Route, NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Row, Col } from 'react-flexbox-grid';

import { bindActionCreators } from 'redux';
import CreateUploadPropertyComp from './CreateUploadPropertyComp.js';
import SelectPlanComp from './SelectPlanComp.js';
import GetClientComp from './GetClientComp.js';
import SeoPerfomanceComp from './SeoPerfomanceComp.js';
import WizardActions from '../actions/wizard.actions';

class WizardComp extends Component {
  componentDidMount() {
    const { project, wizardActions, query, history } = this.props;

    if (query.projectId) {
      return history.replace({
        pathname: history.location.pathname,
        search: history.location.search.replace(/projectId=[a-z0-9]{0,}/, `idx=${project.index}`)
      });
    }

    wizardActions.getPassedSteps({ steps: project.wizard });
  }

  componentWillReceiveProps(nextProps) {
    const query = nextProps.query || {};
    const { project } = this.props;

    const nextProject = nextProps.project;

    if (project.wizard.length === nextProject.wizard.length) return;

    const wizard = nextProject.wizard || [];
    this.props.wizardActions.getPassedSteps({ steps: wizard, idx: query.idx });
  }

  render() {
    const {
      query: { idx, projectId },
      wizard: { steps, passed, next }
    } = this.props;

    if (!idx && projectId) {
      return null;
    }

    return (
      <div className="content wizard">
        <Row center="xs">
          <div className="steps-container">
            <StepsComp
              steps={steps}
              passed={passed.concat(next)}
              idx={idx}
              location={this.props.location}
            />
          </div>
        </Row>
        <section>
          <Route path="/wizard/select-web-property" component={CreateUploadPropertyComp} />
          <Route path="/wizard/select-plan" component={SelectPlanComp} />
          <Route path="/wizard/get-client" component={GetClientComp} />
          <Route path="/wizard/seo-perfomance" component={SeoPerfomanceComp} />
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const search = state.routing.location.search;
  const query = search ? qs.parse(search) : { idx: 0 };

  const { projects } = state.me.user;

  if (query.id) {
    const { index = 0 } = projects.find(({ _id }) => _id === query.id) || {};
    query.idx = index;
  }
  const project = query.projectId
    ? projects.find(({ _id }) => _id == query.projectId)
    : projects.find(({ index }) => index == query.idx);

  return {
    query,
    project,
    me: state.me,
    user: state.me && state.me.user,
    location: state.routing.location,
    wizard: state.wizard
  };
}

function mapDispatchToProps(dispatch) {
  return {
    wizardActions: bindActionCreators(WizardActions, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardComp));

function StepsComp(props) {
  const { idx, location } = props;
  return (
    <Row between="xs" className="wizard-steps">
      {props.steps.map((name, i) => {
        let stepBadge = <div className="wizard-steps_badge">{i + 1}</div>;
        if (!!~props.passed.indexOf(name)) {
          const path = `/wizard/${name}`;
          const isActive = location.pathname === path;
          stepBadge = (
            <NavLink
              className={`wizard-steps_badge ${isActive ? 'active' : ''}`}
              to={`${path}?idx=${idx}`}
            >
              {i + 1}
            </NavLink>
          );
        }
        return <Col key={i}>{stepBadge}</Col>;
      })}
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/wizard/WizardComp.js